// eslint-disable-next-line import/prefer-default-export
export const BESOIN = {
  etat: {
    genere: 'Généré',
    commande: 'Commandé',
    receptionne: 'Receptionné',
    receptionnePartiellement: 'Receptionné partiellement',
  },
};
